module.exports = __webpack_public_path__ + "img/btn-icon-5.6226b86d.png";